import { render, staticRenderFns } from "./viewBudgetDetails.vue?vue&type=template&id=268781ae&"
import script from "./viewBudgetDetails.vue?vue&type=script&lang=js&"
export * from "./viewBudgetDetails.vue?vue&type=script&lang=js&"
import style0 from "./viewBudgetDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports